/* eslint-disable  no-restricted-syntax */
/* eslint-disable  guard-for-in */
import Cookies from 'universal-cookie';
import ReverseMd5 from 'reverse-md5';
import {
  API_BASE_URL,
  API_PAYROLL_BASE_URL,
  API_ANALYTIC_BASE_URL,
  API_ATTENDANCE_METRICS_BASE_URL,
  TALENTA_BASE_URL,
  AVATAR_BASE_URL,
  API_TOKEN_ATTENDANCE,
  API_SECRET_KEY,
  API_V_KEY,
  API_X_KEY,
  SSO_BASE_URL,
  SSO_SIGNOUT_PARAM,
  INSIGHT_BASE_URL,
  SSO_CLIENT_ID,
  API_TOKEN,
  APP_ENV,
  INSIGHT_PLUS_BASE_URL,
  IFRAME_SECRET_KEY,
  IFRAME_IV_KEY,
  SSO_SCOPE
} from 'Config/api';
import {
  LABEL_HEADCOUNT_SERVICE_LENGTH,
  CID,
  UID,
  EXP,
  CIDP,
  CIDX,
  UIDP,
  MONTH_SHORT_NAME,
  CURRENT_USER,
  CURRENT_USER_NUXT,
  NEW_INSIGHT_LINK,
} from 'Config/constants';
import { createBrowserHistory } from 'history';
import _ from 'lodash';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import { cidTemporary } from 'Config/cidTemporary';

// redirect function
export const history = createBrowserHistory();

export const sortByMonthId = (a, b) => {
  return a.month_id.localeCompare(b.month_id);
};

// SetStorage - Set LocalStorage Session
export function SetStorage(key, value, ttl = 0) {
  let attr = { attr: value };
  if (ttl > 0) {
    const now = new Date();
    attr = {
      attr: value,
      expiry: now.getTime() + ttl,
    };
  }
  return localStorage.setItem(key, JSON.stringify(attr));
}
// GetStorage - Get LocalStorage Session
export function GetStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}
// RemoveStorage - Remove LocalStorage Session
export function RemoveStorage(key) {
  return localStorage.removeItem(key);
}

export function formattedDate(paramDate, paramFormat = 'DD-MM-YY') {
  return moment(paramDate).format(paramFormat);
}

// ConvertDataHeadCountTrend
export function ConvertDataHeadCountTrend(data) {
  const currentYear = new Date().getFullYear();
  const lastYearArr = [];
  const currentYearArr = [];
  if (data.length > 0) {
    data.forEach((item) => {
      const monthID = item.month_id.split('-');
      if (Number(monthID[0]) === currentYear) {
        currentYearArr.push(item.count);
      } else {
        lastYearArr.push(item.count);
      }
    });
  }
  return [lastYearArr, currentYearArr];
}

export function convertDataheadcountTurnOverEducation(data, type) {
  const labels = [];

  const labelObj2 = _.uniqBy(
    _.map(data, (item) => {
      return item.month_id;
    })
  );

  labelObj2
    .sort((a, b) => a.localeCompare(b))
    .forEach((item, index) => {
      const monthID = item.split('-');

      if (type === 'quarter') {
        labels.push(`Q${index + 1}`);
      } else {
        labels.push(
          `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
        );
      }
    });

  const mapObj = _.mapValues(_.groupBy(data, 'last_education'), (item) => {
    const params = labelObj2.map((e) => {
      return {
        month: e,
        last_education: _.omit(item[0]).last_education,
        total:
          _.omit(item.find((a) => (a.month_id === e ? a.total : 0))).total || 0,
        percentage:
          _.omit(item.find((a) => (a.month_id === e ? a.percentage : 0)))
            .percentage || 0,
      };
    });
    return params;
  });

  return [labels, mapObj];
}

export function convertDataheadcountTurnOverAge(data) {
  if (data === 0) {
    return [];
  }

  const labels = [];
  const count1824 = [];
  const count2534 = [];
  const count3549 = [];
  const count5064 = [];
  const count64more = [];
  const count18less = [];

  const checkQuarter = data.every((el) =>
    Object.prototype.hasOwnProperty.call(el, 'quarter')
  );

  data
    .sort((a, b) => {
      return a?.month
        ? a.month.localeCompare(b.month)
        : a.quarter.localeCompare(b.quarter);
    })
    .forEach((item, index) => {
      const month = item?.month
        ? item.month.split('-')
        : item?.quarter.split('-');
      const monthID = month;
      const monthly = `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(
        monthID[0]
      )} `;
      if (checkQuarter) {
        labels.push(`Q${index + 1}`);
      } else {
        labels.push(monthly);
      }
      count1824.push(item.count_18_24);
      count2534.push(item.count_25_34);
      count3549.push(item.count_35_49);
      count5064.push(item.count_50_64);
      count64more.push(item.count_more_64);
      count18less.push(item.count_less_18);
    });

  return [
    labels,
    count1824,
    count2534,
    count3549,
    count5064,
    count64more,
    count18less,
  ];
}

export function convertDataheadcountTurnOverWorksPeriod(data) {
  if (data === 0) {
    return [];
  }

  const labels = [];
  const countLt1 = [];
  const countEq1 = [];
  const countEq2 = [];
  const countEq3 = [];
  const countEq4 = [];
  const countGtEq5 = [];

  const checkQuarter = data.every((el) =>
    Object.prototype.hasOwnProperty.call(el, 'quarter')
  );

  data
    .sort((a, b) => {
      return a?.month
        ? a.month.localeCompare(b.month)
        : a.quarter.localeCompare(b.quarter);
    })
    .forEach((item, index) => {
      const month = item?.month ? item.month.split('-') : item?.quarter.split('-');
      const monthID = month;
      const monthly = `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])}`;

      if (checkQuarter) {
        labels.push(`Q${index + 1}`);
      } else {
        labels.push(monthly);
      }

      countLt1.push(item.count_lt_1);
      countEq1.push(item.count_eq_1);
      countEq2.push(item.count_eq_2);
      countEq3.push(item.count_eq_3);
      countEq4.push(item.count_eq_4);
      countGtEq5.push(item.count_gt_eq_5);
    });

  return [
    labels,
    countLt1,
    countEq1,
    countEq2,
    countEq3,
    countEq4,
    countGtEq5,
  ];
}

export function convertDataheadcountTurnoverGender(data) {
  if (data === 0) {
    return [];
  }
  const labels = [];
  const male = [];
  const female = [];
  const percentageMale = [];
  const percentageFemale = [];

  const checkQuarter = data.every((el) =>
    Object.prototype.hasOwnProperty.call(el, 'quarter')
  );

  data
    .sort((a, b) => {
      return a?.month
        ? a.month.localeCompare(b.month)
        : a.quarter.localeCompare(b.quarter);
    })
    .forEach((item, index) => {
      const month = item?.month
        ? item.month.split('-')
        : item?.quarter.split('-');
      const monthID = month;
      const monthly = `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(
        monthID[0]
      )} `;
      if (checkQuarter) {
        labels.push(`Q${index + 1}`);
      } else {
        labels.push(monthly);
      }
      male.push(item.count_male);
      female.push(item.count_female);
      percentageFemale.push(item.percentage_female);
      percentageMale.push(item.percentage_male);
    });

  return [labels, male, female, percentageMale, percentageFemale];
}

export function convertDataheadcountTurnoverVoluntary(data) {
  if (data === 0) {
    return [];
  }
  const labels = [];
  const voluntary = [];
  const inVoluntary = [];
  const percentageVoluntary = [];
  const percentageinVoluntary = [];

  const checkQuarter = data.every((el) =>
    Object.prototype.hasOwnProperty.call(el, 'quarter')
  );

  data
    .sort((a, b) => {
      return a?.month
        ? a.month.localeCompare(b.month)
        : a.quarter.localeCompare(b.quarter);
    })
    .forEach((item, index) => {
      const month = item?.month
        ? item.month.split('-')
        : item?.quarter.split('-');
      const monthID = month;
      const monthly = `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(
        monthID[0]
      )} `;
      if (checkQuarter) {
        labels.push(`Q${index + 1}`);
      } else {
        labels.push(monthly);
      }
      voluntary.push(item.count_voluntary);
      inVoluntary.push(item.count_involuntary);
      percentageVoluntary.push(item.percentage_voluntary);
      percentageinVoluntary.push(item.percentage_involuntary);
    });

  return [
    labels,
    voluntary,
    inVoluntary,
    percentageVoluntary,
    percentageinVoluntary,
  ];
}

export const convertHeadcountResignReason = (data) => {
  if (data.length === 0) return [];

  const labels = [];
  const value = [];
  const labelsFull = [];

  data.forEach((item) => {
    labels.push(
      item?.resign_reason?.length > 15
        ? `${item?.resign_reason.substring(0, 15)}...`
        : item?.resign_reason
      // item?.resign_reason
    );
    value.push(item.count);
    labelsFull.push(item?.resign_reason);
  });

  return [labels, value, labelsFull];
};

export const convertHeadcountReprimandHistory = (data) => {
  if (data.length === 0) return [];

  const labels = [];
  const value = [];

  data
    .sort((a, b) => a.month.localeCompare(b.month))
    .forEach((item) => {
      const monthID = item.month.split('-');
      labels.push(
        `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
      );
      value.push(item.count);
    });
  return [labels, value];
};

export const monthIntervalCurrent = (
  currDate,
  lastDate,
  data,
  type,
  dateValue
) => {
  // let labels = [];
  // let currentYear = [];
  // let lastYear = [];
  // let fromDate = moment(currDate).add(-11, "M");
  // let toDate = moment(currDate);
  const toDateLastYear = moment(lastDate);

  // console.log(currDate, 'lastdate')

  //  new testing
  // let newstartDate, newendDate;

  // if (type === "start") {
  //   newstartDate = moment(currDate);

  //   const range = moment(dateValue.endDate).diff(moment(currDate), "Month");

  //   if (range < 12 && range >= 0) {
  //     newendDate = dateValue.endDate;
  //   } else {
  //     newendDate = moment(currDate).add(11, "M");
  //   }
  // } else {
  //   const range = moment(currDate).diff(moment(dateValue.startDate), "Month");
  //   console.log(range, "range", dateValue.startDate);

  //   newendDate = moment(currDate);
  //   if (range < 12 && range >= 0) {
  //     newstartDate = dateValue.startDate;
  //   } else {
  //     newstartDate = moment(currDate).add(-11, "M");
  //   }
  // }
  const frDate = moment(dateValue.startDate);
  const rangeDate = moment(dateValue.endDate);

  const labels2 = [];
  const currentYear2 = [];
  const lastYear2 = [];

  while (frDate <= rangeDate) {
    data.forEach((item) => {
      if (
        frDate.format('MM-YYYY') === moment(item.month_id).format('MM-YYYY')
      ) {
        currentYear2.push(item.count);
      }

      if (
        toDateLastYear.format('DD-MM-YYYY') ===
        moment(item.month_id).format('DD-MM-YYYY')
      ) {
        lastYear2.push(item.count);
      }
    });
    labels2.push(frDate.format('MMM YYYY'));
    frDate.add(1, 'M');
    toDateLastYear.add(1, 'M');
  }

  // Old
  // while (fromDate <= toDate) {
  //   data.forEach((item) => {
  //     if (
  //       fromDate.format("DD-MM-YYYY") ===
  //       moment(item.month_id).format("DD-MM-YYYY")
  //     ) {
  //       currentYear.push(item.count);
  //     }

  //     if (
  //       toDateLastYear.format("DD-MM-YYYY") ===
  //       moment(item.month_id).format("DD-MM-YYYY")
  //     ) {
  //       lastYear.push(item.count);
  //     }
  //   });
  //   labels.push(fromDate.format("MMM YYYY"));

  //   fromDate.add(1, "M");
  //   toDateLastYear.add(1, "M");
  // }
  // return [labels, currentYear, lastYear];
  return [labels2, currentYear2, lastYear2];
};

export const monthIntervalLastYear = (date, data) => {
  const labels = [];
  const response = [];
  const fromDate = moment(date).add(11, 'M');
  const toDate = moment(date);
  while (toDate <= fromDate) {
    data.forEach((item) => {
      if (
        toDate.format('DD-MM-YYYY') ===
        moment(item.month_id).format('DD-MM-YYYY')
      ) {
        response.push(item.count);
      }
    });
    labels.push(toDate.format('MMM YYYY'));
    toDate.add(1, 'M');
  }
  return [labels, response];
};

export function ConvertDataHeadCountTrendNew(data, type, dateValue) {
  const [label, currentYearArr, lastYearArr] = monthIntervalCurrent(
    data?.[0]?.month_id,
    data?.[data.length - 1]?.month_id,
    data,
    type,
    dateValue
  );
  return [label, currentYearArr, lastYearArr];
}

export function ConvertDataHeadcountResignJoin(data) {
  if (data.length === 0) {
    return [];
  }
  const labels = [];
  const activeCount = [];
  const resignCount = [];
  const joinCount = [];

  data.sort(sortByMonthId).forEach((item) => {
    const monthID = item.month_id.split('-');
    labels.push(
      `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
    );
    activeCount.push(item.active_count);
    resignCount.push(-item.resign_count);
    joinCount.push(item.join_count);
  });

  return [labels, activeCount, resignCount, joinCount];
}

// ConvertDataHeadCountOrganization
export function ConvertDataHeadCountOrganization(data) {
  if (data.length === 0) {
    return [];
  }
  const labels = [];
  const labelsFull = [];
  const lastYearArr = [];
  const currentYearArr = [];
  if (data.length > 0) {
    const mapObj = _.mapValues(_.groupBy(data, 'organization'), (item) => {
      return item.map((x) => _.omit(x));
    });
    for (const org in mapObj) {
      labels.push(org.length > 15 ? `${org.substring(0, 15)}...` : org);
      labelsFull.push(org);
      lastYearArr.push(mapObj[org][1] ? mapObj[org][1].count : 0);
      currentYearArr.push(mapObj[org][0] ? mapObj[org][0].count : 0);
    }
  }
  return [labels, labelsFull, lastYearArr, currentYearArr];
}

// ConvertDataAttendanceTimeoff
export function ConvertDataAttendanceTimeoff(data) {
  const newData = [];

  if (data.length > 0) {
    data.forEach((item) => {
      newData.push({
        employee_id: item.user_id,
        avatar: item.avatar,
        name: item.name,
        role: item.job,
        day_taken: item.total_timeoff,
        previous_month: item.prev_month_timeoff,
      });
    });
  }

  return newData;
}

// ConvertDataHeadCountBreakdown
export function ConvertDataHeadCountBreakdown(data) {
  if (data.length === 0) {
    return [];
  }
  return [data.labels, data.last_year, data.this_year];
}
// GetCurrentEmployee
export function GetCurrentEmployee(data) {
  return data !== undefined && data.length > 0 ? data[0].count : 0;
}
// GetCurrentDate
export function GetCurrentDate() {
  const d = new Date();
  return [d.getMonth(), d.getFullYear(), d.getDate()];
}
// ConvertDataHeadCountServiceLength
export function ConvertDataHeadCountServiceLength(data, date) {
  const currentYear = new Date(date).getFullYear();
  let labels = [];
  const lastYearArr = [];
  const lastYearArrNew = [];
  const currentYearArr = [];
  const currentYearArrNew = [];
  if (data.length > 0) {
    data.forEach((obj) => {
      const keyObjs = Object.keys(obj);
      // Convert year_id to number for comparison
      const yearId = parseInt(obj.year_id, 10);
      if (yearId === currentYear) {
        keyObjs.splice(1).forEach((item) => {
          if (!item.match(/_new/g)) {
            currentYearArr.push(obj[item]);
            labels.push(LABEL_HEADCOUNT_SERVICE_LENGTH[item]);
          } else {
            currentYearArrNew.push(obj[item]);
          }
        });
      } else {
        keyObjs.splice(1).forEach((item) => {
          if (!item.match(/_new/g)) {
            lastYearArr.push(obj[item]);
            labels.push(LABEL_HEADCOUNT_SERVICE_LENGTH[item]);
          } else {
            lastYearArrNew.push(obj[item]);
          }
        });
      }
    });
  }
  labels = [...new Set(labels)];
  return [
    labels,
    lastYearArr,
    lastYearArrNew,
    currentYearArr,
    currentYearArrNew,
  ];
}
// ConvertDataAttendanceTimeoffPolicies ...
export function ConvertDataAttendanceTimeoffPolicies(data) {
  const policies = [];
  data.forEach((option) => {
    policies.push({
      label: option.policy_name,
      value: option.policy_id,
      isChecked: false,
      color: option.color,
    });
  });

  return policies;
}

// ConvertDataAttendanceRecord
export function ConvertDataAttendanceRecord(data) {
  if (data.length === 0) {
    return [];
  }
  const labels = [];
  const absentArrMandays = [];
  const lateArrMandays = [];
  const onTimeArrMandays = [];
  const timeOffArrMandays = [];
  const noCheckInMandays = [];

  data.sort(sortByMonthId).forEach((item) => {
    const monthID = item.month_id.split('-');
    labels.push(
      `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
    );
    absentArrMandays.push(item.absence_mandays);
    lateArrMandays.push(item.late_mandays);
    onTimeArrMandays.push(item.ontime_mandays);
    timeOffArrMandays.push(item.timeoff_mandays);
    noCheckInMandays.push(item.nocheckin_mandays);
  });

  return [
    labels,
    absentArrMandays,
    lateArrMandays,
    onTimeArrMandays,
    timeOffArrMandays,
    noCheckInMandays,
  ];
}

// convert employee attendance pop up
export function ConvertDataEmployeeAttendancePopUp(data) {
  const labels = [];
  const absentArr = [];
  const lateArr = [];
  const earlyOutArr = [];

  data.sort(sortByMonthId).forEach((item) => {
    const monthID = item.month_id.split('-');
    labels.push(
      `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
    );
    absentArr.push(item.total_absence);
    lateArr.push(item.total_late);
    earlyOutArr.push(item.total_earlyout);
  });

  return [labels, absentArr, lateArr, earlyOutArr];
}

// convert attendance time off trends
export function ConvertDataAttendanceTimeoffTrends(data) {
  const labels = [];

  const mapObj = _.mapValues(_.groupBy(data, 'policy_id'), (item) => {
    return item.map((x) => _.omit(x));
  });

  const labelObj2 = _.uniqBy(
    _.map(data, (item) => {
      return item.month_id;
    })
  );
  labelObj2
    .sort((a, b) => a.localeCompare(b))
    .forEach((item) => {
      const monthID = item.split('-');
      labels.push(
        `${MONTH_SHORT_NAME[Number(monthID[1]) - 1]} ${Number(monthID[0])} `
      );
    });
  return [labels, mapObj];
}

// ExplodeCIDParams split params payroll
export function ExplodeCIDParams(params) {
  const arr = params !== null ? params.split('.') : []; // eslint-disable-line
  if (arr.length === 4) {
    return arr;
  }
  return null;
}

export function ExplodeCIDCryptic(params) {
  const arr = params !== null ? params.split('.') : []; // eslint-disable-line
  if (arr.length === 2) {
    return arr;
  }
  return null;
}

// ExtractingParams
export function extractCIDTemporary() {
  const rev = ReverseMd5({
    lettersUpper: false,
    lettersLower: true,
    numbers: true,
    special: false,
    whitespace: false,
    maxLen: 12,
  });

  const params = new URLSearchParams(window.location.search);

  let cid;

  if (!params.get('cid')) return true;

  const urlParams = ExplodeCIDParams(params.get('cid'));

  if (urlParams) {
    cid = rev(urlParams[2])['str']; // eslint-disable-line
    return cidTemporary.includes(Number(cid));
  }

  cid = rev(GetStorage(CIDX)?.attr)['str']; // eslint-disable-line
  return cidTemporary.includes(Number(cid));
}

export function ExtractingParams(params) {
  const rev = ReverseMd5({
    lettersUpper: false,
    lettersLower: false,
    numbers: true,
    special: false,
    whitespace: false,
    maxLen: 12,
  });

  const hashRes = rev(params[2]); // segment 3
  const segment1 = Math.pow(parseInt(hashRes['str']), 2) * 3; // eslint-disable-line
  const seg2val = Math.sqrt(params[1] / 3); // eslint-disable-line
  const segment2 = Math.pow(seg2val, 2) * 3; // eslint-disable-line
  const segment4 = Number(params[3]); // segment 4

  // set check temporary CID

  // compare segment 1 and 3
  if (Number(params[0]) === segment1 && segment2 === Number(params[1])) {
    SetStorage(CID, encryptCID(hashRes['str'])); // eslint-disable-line
    SetStorage(UID, seg2val);
    SetStorage(EXP, segment4);
    SetStorage(CIDP, params[0]);
    SetStorage(UIDP, params[1]);
    SetStorage(CIDX, params[2]);
    return true;
  }
  return false;
}

export function ExtractingCIDParams(params) {
  const rev = ReverseMd5({
    lettersUpper: false,
    lettersLower: true,
    numbers: true,
    special: false,
    whitespace: false,
    maxLen: 12,
  });

  const segment1 = params[0]; // cid^2 * 3
  const segment2 = params[1]; // equal to md5(segment1)
  const reverseMd5 = rev(segment2);
  const decryptSegment2 = Math.pow(parseInt(reverseMd5['str']), 2) * 3; // eslint-disable-line

  // compare segment 1 and 2
  if (Number(segment1) === Number(decryptSegment2)) {
    SetStorage(CID, encryptCID(reverseMd5['str'])); // eslint-disable-line
  }

  return false;
}

// GetAPIBaseURL
export function GetAPIBaseURL() {
  return API_BASE_URL;
}

// get CLIENT IDS SSO
export function GetSSOCLIENTID() {
  return SSO_CLIENT_ID;
}

// get SSO Singout Params
export function GetSSOSignoutParam() {
  return SSO_SIGNOUT_PARAM;
}

// get SSO URL
export function GetSSOURL() {
  return SSO_BASE_URL;
}

// get SSO URL
export function GetSSOScope() {
  return SSO_SCOPE;
}

// Get Insight URL
export function GetInsightURL() {
  return INSIGHT_BASE_URL;
}

// GetPayrollBaseURL
export function GetPayrollBaseURL() {
  return API_PAYROLL_BASE_URL;
}
// GetAPIAttendanceBaseURL
export function GetAPIAttendanceBaseURL() {
  return API_ANALYTIC_BASE_URL;
}
// GetAPIAttendanceMetricBaseURL
export function GetAPIAttendanceMetricsBaseURL() {
  return API_ATTENDANCE_METRICS_BASE_URL;
}
// Talenta url
export function GetTalentaURL() {
  return TALENTA_BASE_URL;
}
// SSO signout url
export function GetSsoSignoutURL() {
  return `${GetSSOURL()}sign_out?client_id=${GetSSOCLIENTID()}&return_to=${GetSSOSignoutParam()}`;
}
// Help support url
export function GetHelpSupportURL() {
  return process.env.REACT_APP_HELP_SUPPORT_URL;
}
// Privacy url
export function GetPrivacyURL() {
  return process.env.REACT_APP_PRIVACY_URL;
}
// Terms of use url
export function GetTermsUseURL() {
  return process.env.REACT_APP_TERMS_USE_URL;
}
// About Mekari account url
export function GetAboutAccountURL() {
  return process.env.REACT_APP_ABOUT_ACCOUNT_URL;
}
// Mekari url
export function GetMekariURL() {
  return process.env.REACT_APP_MEKARI_URL;
}

// GetToken
export function GetToken(token = '') {
  if (token !== '') {
    return token;
  }

  return API_TOKEN;
}

export function getTokenJWT() {
  const cookies = new Cookies();
  return cookies.get('insight_token');
}
// GetTokenAttendance
export function GetTokenAttendance(token = '') {
  if (token !== '') {
    return token;
  }

  return API_TOKEN_ATTENDANCE;
}
// CheckSessionExpired
export function CheckSessionExpired() {
  const exp = GetStorage(EXP);
  if (!exp) {
    return false;
  }
  const HOUR = 1000 * 60 * 60;
  const anHourAgo = Date.now() - HOUR;
  let timeout = new Date(exp.attr * 1000);
  if (exp.attr.toString().length > 10) {
    timeout = new Date(exp.attr);
  }
  if (timeout.getTime() > anHourAgo) {
    return true;
  }
  RemoveStorage(CID);
  RemoveStorage(CIDP);
  RemoveStorage(UID);
  RemoveStorage(UIDP);
  RemoveStorage(EXP);
  return false;
}
// cleanup local cookie storage
export function CleanupSessionStorage() {
  const cookies = new Cookies();
  cookies.remove('insight_token');
  RemoveStorage(CURRENT_USER);
  RemoveStorage(CURRENT_USER_NUXT)
  return false
}
// cleanup cryptic storage
export function CleanupCrypticStorage() {
  RemoveStorage(CID);
  RemoveStorage(CIDP);
  RemoveStorage(UID);
  RemoveStorage(UIDP);
  RemoveStorage(EXP);
  return false;
}
// HasCIDSession
export function HasCIDSession() {
  if (GetStorage(CID) && GetStorage(UID)) {
    return true;
  }
  return false;
}
// ConvertOptionFilter
export function ConvertOptionFilter(data) {
  const options = [];
  data.forEach((option) => {
    options.push({
      label: option.name,
      value: option.id,
      isChecked: false,
    });
  });

  return options;
}

// Sort Items
export const sortItems = (prev, curr, columnId) => {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  });

  return collator.compare(prev.original[columnId], curr.original[columnId]);
};

// Name Initial
export const getInitials = (fullName) => {
  let initials;

  if (!fullName) {
    return 0;
  }

  const name = String(fullName).trim().split(' ');
  initials = name[0].substring(0, 1).toUpperCase();

  if (name.length > 1) {
    initials += name[name.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

// get Avatar
export const getAvatar = (avatar, fullName) => {
  if (avatar) {
    return `${process.env.REACT_APP_AVATAR_URL}${avatar}`;
  }
  return getInitials(fullName);
};
export const getAvatarImg = (path) => {
  return `${AVATAR_BASE_URL}${path}`;
};

export const getPathMenu = () => {
  const pathArr = window.location.pathname.split('/');
  const pathName = pathArr[pathArr.length - 1];

  switch (true) {
    case pathName === '':
      return 'headcount';
    case pathName === 'payroll-insight':
      return 'payroll';
    case pathName === 'employee-at-risk':
      return 'employee_risk';
    case ['attendance', 'overtime'].includes(pathName):
      return pathName;
    default:
      return '';
  }
}

export const titleCase = (s) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase()) // eslint-disable-line

const cryptoJSParams = () => {
  const secretKey = API_SECRET_KEY;
  const vkey = API_V_KEY;
  const key = CryptoJS.SHA256(secretKey).toString().substring(0, 32);
  const iv = CryptoJS.SHA256(vkey).toString().substring(0, 16);

  return {
    key,
    iv,
  };
};
// encrypt cid
export const encryptCID = (cid, prefix = '') => {
  const { key, iv } = cryptoJSParams();

  const encrypted = CryptoJS.AES.encrypt(cid, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Utf8.parse(iv),
  }).toString();

  const newEncrypted = CryptoJS.enc.Utf8.parse(encrypted);

  const withPrefix = `${prefix}${CryptoJS.enc.Base64.stringify(newEncrypted)}`;
  return prefix !== ''
    ? withPrefix
    : CryptoJS.enc.Base64.stringify(newEncrypted);
};

// decrypt CID
export const decryptCID = (cid) => {
  if (!cid) return false;
  const { key, iv } = cryptoJSParams();

  const encryptedText = CryptoJS.enc.Base64.parse(cid);

  const encryptStringify = CryptoJS.enc.Utf8.stringify(encryptedText);

  const decrypt = CryptoJS.AES.decrypt(
    encryptStringify,
    CryptoJS.enc.Utf8.parse(key),
    {
      mode: CryptoJS.mode.CBC,
      iv: CryptoJS.enc.Utf8.parse(iv),
    }
  ).toString(CryptoJS.enc.Utf8);

  return decrypt;
};

const currentUserKey = () => {
  const { key, iv } = cryptoJSParams();
  return CryptoJS.enc.Utf8.parse(key) + CryptoJS.enc.Utf8.parse(iv);
}

// current user encryption
export const SignCurrentUser = (payload) => {
  return CryptoJS.AES.encrypt(JSON.stringify(payload), currentUserKey()).toString();
}

export const DecodeCurrentUser = () => {
  const token = GetStorage(CURRENT_USER)?.attr
  if (token) {
    return CryptoJS.AES.decrypt(token, currentUserKey()).toString(CryptoJS.enc.Utf8);
  }
  return false;
}

export const CrypticCurrentCompanyId = () => {
  const currentCompanyId = JSON.parse(DecodeCurrentUser())?.current_company.company.id;
  return currentCompanyId * currentCompanyId * 3;
}

export const CrypticUid = () => {
  const currentUser = JSON.parse(DecodeCurrentUser())?.current_user;
  return currentUser.id * currentUser.id * 3;
}

export const CrypticExp = () => {
  return JSON.parse(DecodeCurrentUser())?.exp;
}

export const snakeCase = string => {
  return string.replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
};

export const RoleValidate = (menu) => {
  const currentCompany = JSON.parse(DecodeCurrentUser())?.current_company;
  const roleType = snakeCase(`${currentCompany?.role}_${currentCompany?.role_type}`);
  const roleDetail = currentCompany?.role_detail;
  const ess = currentCompany?.ess;
  const originRoleId = currentCompany?.id;
  let allowed = true;

  // role id by default system
  // 1	=> Super Admin
  // 2	=> Employee
  // 3	=> Admin
  // default role type => get ess attribute
  // custom role type => get role_detail attribute

  // super admin default set by system
  if (['super_admin_default', 'consultant_super_admin_default'].includes(roleType) && originRoleId === 1) {
    allowed = true;
  }

  // admin default set by system
  if (['admin_default', 'consultant_admin_default'].includes(roleType) && originRoleId === 3) {
    if (menu === 'payroll') {
      allowed = false;
    }
  }

  // super admin default set by user
  if (['super_admin_default', 'consultant_super_admin_default'].includes(roleType) && originRoleId !== 1) {
    if (menu === 'headcount') {
      allowed = ess?.employee?.view === 1;
    }

    if (menu === 'attendance') {
      allowed = ess?.attendance?.view === 1 || roleDetail?.report?.attendance_report?.view === 1
    }

    if (menu === 'payroll') {
      allowed = ess?.payroll?.view === 1;
    }

    if (menu === 'employee_risk') {
      allowed = ess?.employee?.view;
    }

    if (menu === 'overtime') {
      allowed = ess?.payroll?.view === 1;
    }
  }

  // admin default set by user
  if (['admin_default', 'consultant_admin_default'].includes(roleType) && originRoleId !== 3) {
    if (menu === 'headcount') {
      allowed = ess?.employee?.view === 1;
    }

    if (menu === 'attendance') {
      allowed = ess?.attendance?.view === 1;
    }

    if (menu === 'payroll') {
      allowed = false;
    }

    if (menu === 'employee_risk') {
      allowed = ess?.employee?.view === 1;
    }

    if (menu === 'overtime') {
      allowed = ess?.payroll?.view_report === 1;
    }
  }

  // super admin custom
  if (['super_admin_custom', 'consultant_super_admin_custom'].includes(roleType)) {
    if (menu === 'headcount') {
      allowed = roleDetail?.employee?.employee?.view === 1 || roleDetail?.report?.hr_report?.view === 1
    }

    if (menu === 'attendance') {
      allowed = roleDetail?.attendance?.attendances?.view === 1 || roleDetail?.report?.attendance_report?.view === 1
    }

    if (menu === 'payroll') {
      allowed = roleDetail?.payroll?.run_payroll?.edit === 1 || roleDetail?.payroll?.run_payroll?.add === 1
    }

    if (menu === 'employee_risk') {
      allowed = roleDetail?.employee?.employee?.view === 1 || roleDetail?.report?.hr_report?.view === 1
    }

    if (menu === 'overtime') {
      allowed = roleDetail?.report?.overtime_report?.view === 1
    }
  }

  // admin custom
  if (['admin_custom', 'consultant_admin_custom'].includes(roleType)) {
    if (menu === 'headcount') {
      allowed = roleDetail?.employee?.employee?.view === 1;
    }

    if (menu === 'attendance') {
      allowed = roleDetail?.employee?.employee?.view === 1 && roleDetail?.attendance?.attendances?.view === 1
    }

    if (menu === 'payroll') {
      allowed = false;
    }

    if (menu === 'employee_risk') {
      allowed = roleDetail?.employee?.employee?.view === 1 || roleDetail?.report?.hr_report?.view === 1;
    }

    if (menu === 'overtime') {
      allowed = roleDetail?.report?.overtime_report?.view === 1;
    }
  }

  return allowed;
}

export function getAPIKeyMetrics() {
  return API_X_KEY;
}

export function cidWithPrefix(prefix) {
  return `${prefix}${GetStorage(CID)?.attr}`;
}

// Passing Value for Product Tour (Lou)
export function GenerateDataProductTour() {
  if (DecodeCurrentUser() !== false) {
    const parseDecodedCurrentUser = JSON.parse(DecodeCurrentUser());
    const getDecodedCurrentUser = parseDecodedCurrentUser?.current_user;
    const getDecodedCurrentCompany = parseDecodedCurrentUser?.current_company;

    return {
      sso_id: getDecodedCurrentUser?.sso_id,
      user_id: `t_${getDecodedCurrentUser?.id}`,
      name: `${getDecodedCurrentUser?.first_name} ${getDecodedCurrentUser?.last_name}`,
      email: getDecodedCurrentUser?.email,
      company: {
        id: `t_${getDecodedCurrentCompany?.company?.id}`,
        name: getDecodedCurrentCompany?.company?.name,
        sso_id: getDecodedCurrentCompany?.company?.sso_id,
        size: getDecodedCurrentCompany.company?.size,
        status: getDecodedCurrentCompany.company?.status,
        go_live_status: (getDecodedCurrentCompany?.company?.is_go_live || '').toString()
      },
      role_id: getDecodedCurrentCompany?.role_id,
      role_name: getDecodedCurrentCompany?.role,
      is_login_insight: "true",
      is_staging: (APP_ENV !== 'production').toString(),
    };
  }

  return false;
}

// Employee At Risk

// overview
export function convertDataAttritionsOverview(data) {
  if (data.length === 0) {
    return [];
  }

  const countRiskLevel = [];
  let total = 0;
  const percentRiskLevel = [];

  Object.entries(data[0]).forEach((item) => {
    if (item[0].includes('count')) {
      countRiskLevel.push(item[1]);
    }
    if (item[0].includes('total')) {
      total = item[1]; // eslint-disable-line
    }
    if (item[0].includes('percent')) {
      percentRiskLevel.push(item[1]);
    }
  });

  let dataPotentialLeave = [
    {
      type: 'High Risk',
      total: 0,
      percent: 0,
    },
    {
      type: 'Medium Risk',
      total: 0,
      percent: 0,
    },
    {
      type: 'Low Risk',
      total: 0,
      percent: 0,
    },
  ];

  dataPotentialLeave = dataPotentialLeave.map((data, index) => {
    return {
      ...data,
      total: countRiskLevel[index],
      percent: percentRiskLevel[index],
    };
  });

  return [countRiskLevel, total, percentRiskLevel, dataPotentialLeave];
}

// ConvertDataAttendanceRecord
export function ConvertDataAttritionOverviewFilter(datas) {
  if (datas.length === 0) {
    return [];
  }

  const data = datas;
  const labels = [];
  const labelsFull = [];
  const highRisk = [];
  const mediumRisk = [];
  const lowRisk = [];
  const percentHighRisk = [];
  const percentMediumRisk = [];
  const percentLowRisk = [];
  const total = [];

  data.forEach((item) => {
    labels.push(
      item?.name?.length > 15 ? `${item?.name.substring(0, 15)}...` : item?.name
    );
    labelsFull.push(item?.name);
    highRisk.push(item.count_high_risk);
    mediumRisk.push(item.count_med_risk);
    lowRisk.push(item.count_low_risk);
    total.push(item.total);
    percentHighRisk.push(item.percent_high_risk);
    percentMediumRisk.push(item.percent_med_risk);
    percentLowRisk.push(item.percent_low_risk);
  });
  return [
    labels,
    labelsFull,
    highRisk,
    mediumRisk,
    lowRisk,
    percentHighRisk,
    percentMediumRisk,
    percentLowRisk,
    total,
  ];
}

// Horizontal barchart js
export const customHeightHorizontalBarCHart = (dataLength, chart, size) => {
  if (dataLength >= 1 && dataLength <= 2) {
    chart.height = 80;
    size.height = 80;
  }
  if (dataLength >= 2 && dataLength < 5) {
    chart.height = 100;
    size.height = 100;
  }
  if (dataLength >= 5 && dataLength <= 8) {
    chart.height = 150;
    size.height = 150;
  }
  if (dataLength > 8 && dataLength <= 10) {
    chart.height = 250;
    size.height = 250;
  }
  if (dataLength > 10 && dataLength <= 20) {
    chart.height = 400;
    size.height = 400;
  }
  if (dataLength > 20) {
    chart.height = 700;
    size.height = 700;
  }

  return chart.update();
};

export const horizontalBarHeight = (dataLength, heights = 100) => {
  let height = heights;
  if (dataLength === 1) {
    height = 15;
  }
  if (dataLength === 2) {
    height = 13;
  }
  if (dataLength > 2 && dataLength < 5) {
    height = 30;
  }
  if (dataLength >= 5 && dataLength <= 8) {
    height = 50;
  }
  if (dataLength > 8 && dataLength <= 10) {
    height = 70;
  }
  if (dataLength > 10 && dataLength <= 20) {
    height = 80;
  }
  if (dataLength < 30) {
    height = dataLength * 5;
  }

  if (dataLength >= 30) {
    height = dataLength * 3;
  }

  return height;
};

// Export CSV
export const exportCSV = (dataCSV, fileName) => {
  if (!dataCSV) return;

  const csvContent = `data:text/csv;charset=utf-8, ${dataCSV
    .map((e) => e.join(','))
    .join('\n')}`;

  const encodeUri = encodeURI(csvContent);

  const link = document.createElement('a');
  link.setAttribute('href', encodeUri);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export const RedirectToSso = () => {
  const ssoUrl = `${GetSSOURL()}auth?client_id=${GetSSOCLIENTID()}&response_type=code&scope=${GetSSOScope()}&redirect_uri=${encodeURI(INSIGHT_BASE_URL)}sso-callback`;
  window.location.assign(ssoUrl);

  return true;
};

export const RedirectToSsoSignout = () => (
  window.location.assign(GetSsoSignoutURL())
);

export const RedirectToManagerDashboard = () => {
  window.location.assign(NEW_INSIGHT_LINK.teamAttendance);
};

export const RedirectToNewPayroll = () => {
  window.location.assign(NEW_INSIGHT_LINK.payroll);
};

// Get insight plus landing url 
export function getInsightPlusUrl() {
  return INSIGHT_PLUS_BASE_URL;
}

// encrypt data for parameter insightplus landing
export const encryptIframeParams = (data) => {
  const key = CryptoJS.SHA256(IFRAME_SECRET_KEY).toString().substring(0, 32);
  const iv = CryptoJS.SHA256(IFRAME_IV_KEY).toString().substring(0, 16);
  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Utf8.parse(iv),
  }).toString();
  const newEncrypted = CryptoJS.enc.Utf8.parse(encrypted);

  return CryptoJS.enc.Base64.stringify(newEncrypted);
};

export const IsMenuEmployee = (accessMenu) =>
(accessMenu.team_manager
  && !accessMenu.headcount
  && !accessMenu.attendance
  && !accessMenu.payroll
  && !accessMenu.employee_risk
  && !accessMenu.overtime)
